"use strict";

const searchExecutionTracking = function() {
  const searchBtn = document.querySelector('button[data-test-id]')
  if (searchBtn) {
    searchBtn.addEventListener('click', (evt) => {
      const target = evt.target.nodeName.toLowerCase() !== 'button' ? evt.target.parentElement : evt.target;
      if (target && target.nodeName.toLowerCase() === 'button') {
        ut.push([
          'gtm',
          'click',
          {
            eventcategory: 'search',
            eventaction: target.getAttribute('data-test-id'),
            eventlabel: 'home'
          },
        ]);
      }
    });
  }
};

const refineSearchTracking = function() {
  const refineSearchLink = document.querySelector('a[data-test-id]')
  if (refineSearchLink) {
    refineSearchLink.addEventListener('click', (evt) => {
      ut.push([
        'gtm',
        'click',
        {
          eventcategory: 'search',
          eventaction: evt.target.getAttribute('data-test-id'),
          eventlabel: 'home'
        },
      ]);
    });
  }
};

const initSearchMaskTracking = function() {
  searchExecutionTracking();
  refineSearchTracking();
};

module.exports = {
  init: initSearchMaskTracking
};
